module.exports = __webpack_public_path__ + "img/Connecting-Through-Zoom.1259b696.png";